import React from 'react';
import { FormGroup, FormInput, ModalBody } from 'shards-react';
import SelectOptionsType from '../../common/SelectOptionsType';
import type { Language, SteelMaker } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

interface ModalEditBodyProps {
  // インプット関連
  labelCode: string;
  labelName: string;
  code: string;
  name: string;
  disabledCode: boolean;
  disabledName: boolean;
  invalidCode: boolean;
  invalidName: boolean;
  isNotUnique: boolean;
  isNotUniqueText: string;
  onChangeCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // プルダウン関連
  selectId: string;
  selectClass: string;
  steelMaker: OptionsType;
  options: OptionsType[];
  placeholder: string;
  language: Language;
  optionsFilter: (options: OptionsType<SteelMaker>[]) => OptionsType<SteelMaker>[];
  onChangeSelect: (steelMaker: OptionsType<SteelMaker>) => void;
}

const ModalEditBody = ({
  labelCode,
  labelName,
  code,
  name,
  disabledCode,
  disabledName,
  invalidCode,
  invalidName,
  isNotUnique,
  isNotUniqueText,
  onChangeCode,
  onChangeName,
  selectId,
  selectClass,
  steelMaker,
  options,
  placeholder,
  language,
  optionsFilter,
  onChangeSelect,
}: ModalEditBodyProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(d);
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <SelectOptionsType
        id={selectId}
        className={selectClass}
        value={steelMaker}
        options={options}
        placeholder={placeholder}
        language={language}
        optionsFilter={optionsFilter}
        onChange={onChangeSelect}
      />
      <FormGroup>
        <label htmlFor="code">{labelCode}</label>
        <FormInput id="code" className="mb-3" value={code} disabled={disabledCode} invalid={invalidCode} onChange={onChangeCode} />
      </FormGroup>
      <FormGroup>
        <label htmlFor="name">{labelName}</label>
        <FormInput id="name" className="mb-3" value={name} disabled={disabledName} invalid={invalidName} onChange={onChangeName} />
      </FormGroup>
      {isNotUnique && <span>{isNotUniqueText}</span>}
    </ModalBody>
  );
};

export default ModalEditBody;
